import { render, staticRenderFns } from "./TableFlagItemForm.vue?vue&type=template&id=5e750300&"
import script from "./TableFlagItemForm.vue?vue&type=script&lang=js&"
export * from "./TableFlagItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports